import { Routes, Route } from "react-router-dom";

import Home from "../pages/Home";
import About from "../pages/About";
import Contact from "../pages/Contact";
import Location from "../pages/Location";
import Price from "../pages/Price";
import Virtual from "../pages/Virtual";
import PrivateOffices from "../pages/PrivateOffices";
import ExectiveOffices from "../pages/ExectiveOffices";
import Cont from "../pages/Cont";
import Privacy from "../pages/Privacy";
import NotFound from "../pages/NotFound";

const Routers = () => {
  return (
    <Routes>
      {/* Home */}
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />

      {/* Main Pages */}
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />

      {/* Services */}
      <Route path="/uptown-post-oak" element={<Location />} />
      <Route path="/pricing" element={<Price />} />
      <Route path="/virtual-office" element={<Virtual />} />
      <Route path="/private-offices" element={<PrivateOffices />} />
      <Route path="/executive-suites" element={<ExectiveOffices />} />

      {/* Other Pages */}
      <Route
        path="/xceed-networking-event"
        element={<Cont />}
      />
      <Route
        path="/privacy-policy"
        element={<Privacy />}
      />

      {/* 404 Page */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Routers;